import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ImageWithCorner from 'apps/fops/components/fopPartials/ImageWithCorner';
import ShoppingListsForm from './ShoppingListsForm';
import ShoppingListsItem from './ShoppingListsItem';
import LoadingSpinner from 'apps/loaders/components/LoadingSpinner';

export default class ShoppingListsModal extends PureComponent {
  static propTypes = {
    addNew: PropTypes.bool.isRequired,
    addToShoppingList: PropTypes.func.isRequired,
    addToShoppingListFromBasket: PropTypes.func.isRequired,
    basket: PropTypes.object.isRequired,
    closeForm: PropTypes.func.isRequired,
    createShoppingList: PropTypes.func.isRequired,
    createShoppingListFromBasket: PropTypes.func.isRequired,
    fromBasket: PropTypes.bool,
    items: PropTypes.array.isRequired,
    loadAllShoppingLists: PropTypes.func.isRequired,
    loadShoppingListsForSku: PropTypes.func.isRequired,
    newShoppingList: PropTypes.string.isRequired,
    openForm: PropTypes.func.isRequired,
    pending: PropTypes.bool.isRequired,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    updateNewShoppingListField: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (this.props.fromBasket) {
      this.props.loadAllShoppingLists();
    } else {
      this.props.loadShoppingListsForSku(this.props.product.sku);
    }
  }

  componentWillUnmount() {
    this.props.closeForm();
  }

  showForm = () => {
    this.props.openForm();
  };

  handleAddShoppingList = (shoppingListName) => {
    if (this.props.fromBasket) {
      this.props.createShoppingListFromBasket(shoppingListName, this.props.basket);
    } else {
      this.props.createShoppingList(shoppingListName, this.props.product.sku);
    }
  };

  handleAddToShoppingList = (shoppingListId) => {
    if (this.props.fromBasket) {
      this.props.addToShoppingListFromBasket(shoppingListId, this.props.basket);
    } else {
      this.props.addToShoppingList(shoppingListId, this.props.product.sku);
    }
  };

  handleChangeValue = (value) => {
    this.props.updateNewShoppingListField(value);
  };

  renderInfo() {
    if (this.props.fromBasket) {
      const { basket } = this.props;

      return (
        <div className="sl-modal__content--teaser">
          <div className="sl-modal__content--basket">{basket.numberOfItems}</div>
          <p className="sl-modal__content--description">
            <span>
              You&rsquo;re adding {basket.numberOfItems} {basket.numberOfItems === 1 ? 'item' : 'items'}{' '}
               from your trolley.
            </span>
          </p>
        </div>
      );
    }

    const { product } = this.props;

    return (
      <div className="sl-modal__content--teaser">
        <ImageWithCorner
          product={product}
          extraClass="sl-modal__content--image"
        />
        <p className="sl-modal__content--description">
          <span>
            You&rsquo;re adding {product.name}
          </span>
        </p>
      </div>
    );
  }

  renderShoppingLists() {
    const { items } = this.props;

    if (!items || !items.length) {
      return null;
    }

    return (
      <div className="sl-modal__content--listSection">
        <h2>Select an existing list, or create a new one:</h2>
        <ul className="sl-modal__content--list">
          {items.map((shoppingList) => (
            <ShoppingListsItem
              key={shoppingList.listId}
              shoppingList={shoppingList}
              onAddToShoppingList={this.handleAddToShoppingList}
            />
          ))}
        </ul>
      </div>
    );
  }

  render() {
    const { addNew, items, pending, newShoppingList } = this.props;

    return (
      <div className="sl-modal">
        <div className="sl-modal__content">
          <div className="sl-modal__content--addToList">
            {this.renderInfo()}
            {addNew || items.length === 0 ? (
              <ShoppingListsForm
                onAddNewShoppingList={this.handleAddShoppingList}
                onChangeValue={this.handleChangeValue}
                value={newShoppingList}
              />
            ) : (
              <div className="btn-wrapper sl-modal__content--buttonContainer">
                <button className="sl-modal__content--button btn-secondary" onClick={this.showForm}>
                  <span>Create new list</span>
                </button>
              </div>
            )}
            {pending ? <LoadingSpinner /> : this.renderShoppingLists()}
          </div>
        </div>
      </div>
    );
  }
}
